import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { navLinks, site } from "@/mocks/site";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const solid = scrolled || !isHome || menuOpen;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50 border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 md:h-[72px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 cursor-pointer" aria-label={`${site.name} 首页`}>
          <span
            className={`w-9 h-9 flex items-center justify-center rounded-md font-heading text-lg font-bold transition-colors ${
              solid ? "bg-primary-500 text-background-50" : "bg-background-50/90 text-primary-700"
            }`}
          >
            回
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-lg font-bold tracking-wide transition-colors ${
                solid ? "text-foreground-950" : "text-background-50"
              }`}
            >
              {site.name}
            </span>
            <span
              className={`hidden sm:block text-[11px] tracking-widest mt-0.5 transition-colors ${
                solid ? "text-foreground-500" : "text-background-100/80"
              }`}
            >
              网暴亲历者档案
            </span>
          </span>
        </Link>

        <ul className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <li key={link.to}>
              <NavLink
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                    isActive
                      ? "text-primary-600 bg-primary-50"
                      : solid
                        ? "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                        : "text-background-100 hover:text-background-50 hover:bg-background-50/10"
                  }`
                }
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/about#help"
            className="px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
          >
            寻求帮助
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
          aria-expanded={menuOpen}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer transition-colors ${
            solid ? "text-foreground-900 hover:bg-background-100" : "text-background-50 hover:bg-background-50/10"
          }`}
        >
          <i className={`text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.to}>
                <NavLink
                  to={link.to}
                  end={link.to === "/"}
                  className={({ isActive }) =>
                    `block px-4 py-3 rounded-md text-sm font-medium cursor-pointer transition-colors ${
                      isActive
                        ? "text-primary-600 bg-primary-50"
                        : "text-foreground-700 hover:bg-background-100"
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>
          <Link
            to="/about#help"
            className="mt-3 block text-center px-4 py-3 rounded-md text-sm font-medium cursor-pointer bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
          >
            寻求帮助
          </Link>
        </div>
      )}
    </header>
  );
}